import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapList } from '../common/rest.operators';

import { NavItem, NavLoader, NavModelTransformer } from './nav.model';

@Injectable()
export class NavService {
    nav: NavItem[];
    private _nav: NavLoader;

    constructor(
        private readonly _http: HttpClient,
        private readonly _router: Router,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    list(forceReload?: boolean): Observable<NavItem[]> {
        if (!forceReload && !!this.nav) {
            return of(this.nav);
        }

        const params = new HttpParams().set('menuTypeId', '1');

        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.NAVIGATION}/navigation/GetUserMenus`,
                { params },
            )
            .pipe(
                mapList(new NavModelTransformer(this._router)),
                // eslint-disable-next-line no-return-assign
                tap((model) => (this.nav = model)),
                catchError((error) => {
                    console.error(error);
                    return of([]);
                }),
            );
    }

    reset(): void {
        this.nav = null;
    }

    register(nav: NavLoader): void {
        this._nav = nav;
    }

    reload(forceReload: boolean): Observable<any> {
        if (!this._nav) return;
        this._nav.loadPhoto().subscribe(null, () => null);
        return this._nav.load(forceReload);
    }
}
